import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode(" 다운로드 ")
const _hoisted_2 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_button = _resolveComponent("a-button")!
  const _component_MediaModal = _resolveComponent("MediaModal")!
  const _component_a_table = _resolveComponent("a-table")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.isDownload)
      ? (_openBlock(), _createBlock(_component_a_button, {
          key: 0,
          type: "primary",
          class: "self-start mb-4",
          onClick: _ctx.downloadFiles
        }, {
          default: _withCtx(() => [
            _hoisted_1
          ]),
          _: 1
        }, 8, ["onClick"]))
      : _createCommentVNode("", true),
    _createVNode(_component_a_table, {
      "data-source": _ctx.list,
      columns: _ctx.state.columns,
      "row-key": "id",
      "row-selection": {
      selectedRowKeys: _ctx.state.selectedKey,
      onChange: _ctx.onSelectChange,
    }
    }, {
      bodyCell: _withCtx(({ column, text, record }) => [
        (column.dataIndex === 'modifyDate')
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createTextVNode(_toDisplayString(_ctx.dateFormat(text)), 1)
            ], 64))
          : (column.dataIndex === 'targetFace')
            ? (_openBlock(), _createElementBlock("img", {
                key: 1,
                src: text.url,
                class: "w-24 h-24"
              }, null, 8, _hoisted_2))
            : (column.dataIndex === 'scenario')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createTextVNode(_toDisplayString(text.name), 1)
                ], 64))
              : (column.dataIndex === 'progress')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                    _createTextVNode(_toDisplayString(text) + "% ", 1)
                  ], 64))
                : (column.dataIndex === 'url')
                  ? (_openBlock(), _createBlock(_component_MediaModal, {
                      key: 4,
                      "media-type": _ctx.mediaType,
                      src: text,
                      "file-key": record.id
                    }, null, 8, ["media-type", "src", "file-key"]))
                  : (column.dataIndex === 'finishedAt')
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 5 }, [
                        _createTextVNode(_toDisplayString() + " " + _toDisplayString(_ctx.getDateTime(text)), 1)
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                        _createTextVNode(_toDisplayString(text), 1)
                      ], 64))
      ]),
      _: 1
    }, 8, ["data-source", "columns", "row-selection"])
  ], 64))
}